export default __webpack_public_path__ + "static/media/rubik-v12-latin-300.05e1afc0.eot";